import React from 'react';
import { useTranslation } from '../../utils/useTranslation';
import { Button } from '../input/Button';
import { Box } from '../layout/Box';
import { Flex } from '../layout/Flex';
import { Typography } from '../typography/Typography';

interface BlockedStatusProps {
    login?: string;
}

export const BlockedStatus = (props: BlockedStatusProps) => {
    const t = useTranslation();
    const { login } = props;

    return (
        <Box py={1} px={{ xs: 2, sm: 3 }}>
            <Box backgroundColor="var(--badge-danger-bg-color)" borderRadius={2} p={2}>
                <Typography variant="title3" weight="bold" pb={1}>
                    {t('Бизнес-профиль заблокирован')}
                </Typography>
                <Typography variant="body2" pb={2}>
                    {t(
                        'Ваш бизнес-профиль был заблокирован за нарушение правил сервиса. Если у вас возникли вопросы, пожалуйста, свяжитесь со службой поддержки.',
                    )}
                </Typography>
                <Flex direction="row" justifyContent={{ xs: 'center', sm: 'end' }} spacing={1}>
                    <Button
                        as="a"
                        href="https://yandex.ru/support2/rythm/ru/buisness/moderation"
                        target="_blank"
                        variant="filled"
                        color="primary"
                        width={{ xs: '50%', sm: 'auto' }}
                    >
                        Правила сервиса
                    </Button>
                    <Button
                        as="a"
                        href={
                            process.env.REACT_APP_SUPPORT_FORM_LINK
                                ? `${process.env.REACT_APP_SUPPORT_FORM_LINK}?login=${login}`
                                : ''
                        }
                        target="_blank"
                        variant="filled"
                        color="primary"
                        width={{ xs: '50%', sm: 'auto' }}
                    >
                        Поддержка
                    </Button>
                </Flex>
            </Box>
        </Box>
    );
};
